import React from 'react';
import { SupplementArticle } from './components/SupplementArticle';
export function App() {
  return <SupplementArticle data-id="element-0" />;
}